import React, {PropsWithChildren} from 'react';
import MediaQuery from 'react-responsive';

const xs = 480;
const sm = 768;
const md = 992;
const lg = 1200;

const XS = ({children}: PropsWithChildren) => <MediaQuery maxWidth={xs - 1}>{children}</MediaQuery>;

const MS = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={xs} maxWidth={sm - 1}>
    {children}
  </MediaQuery>
);

const SM = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={sm} maxWidth={md - 1}>
    {children}
  </MediaQuery>
);

const MD = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={md} maxWidth={lg - 1}>
    {children}
  </MediaQuery>
);

const LG = ({children}: PropsWithChildren) => <MediaQuery minWidth={lg}>{children}</MediaQuery>;

const MS_AND_DOWN = ({children}: PropsWithChildren) => (
  <MediaQuery maxWidth={sm - 1}>{children}</MediaQuery>
);

const SM_AND_DOWN = ({children}: PropsWithChildren) => (
  <MediaQuery maxWidth={md - 1}>{children}</MediaQuery>
);

const MD_AND_DOWN = ({children}: PropsWithChildren) => (
  <MediaQuery maxWidth={lg - 1}>{children}</MediaQuery>
);

const MS_AND_UP = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={xs}>{children}</MediaQuery>
);

const SM_AND_UP = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={sm}>{children}</MediaQuery>
);

const MD_AND_UP = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={md}>{children}</MediaQuery>
);

const LG_AND_UP = ({children}: PropsWithChildren) => (
  <MediaQuery minWidth={lg}>{children}</MediaQuery>
);

const print = ({children}: PropsWithChildren) => <MediaQuery query="print">{children}</MediaQuery>;

export default {
  XS,
  MS,
  SM,
  MD,
  LG,
  MS_AND_DOWN,
  SM_AND_DOWN,
  MD_AND_DOWN,
  MS_AND_UP,
  SM_AND_UP,
  MD_AND_UP,
  LG_AND_UP,
  print,
};
